import React from "react";
import MobileRecording from "./mobileRecording";
import MobileCancelButton from "../button/mobileCancelButton";
import MobileSaveButton from "../button/mobileSaveButton";
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import {toast} from "react-toastify";

class MobileRecordingShowOverview extends MobileRecording {
    constructor(props) {
        super();
    }

    state = {toastIsClosed: false};

    onCloseToastHandler = null;
    toastIsOpened = false;
    buttonIsClicked = false;

    closeToast = () => {
        if (this.buttonIsClicked === false) {
            this.setState({toastIsClosed: true});

            if (this.onCloseToastHandler !== null) {
                this.onCloseToastHandler();
            }
        }
    };

    clickButton = onHandler => {
        this.buttonIsClicked = true;
        toast.dismiss();
        onHandler();
    };

    getOutputData = listedFieldItem => {
        // gueltige Ausgaben:
        // - bookingCode
        // - personNumber
        // - absenceNumber
        // - bookingCode
        // - person.person.firstname
        // - person.person.surname
        // - person.person.firstname + person.person.surnamename

        const {recordData} = this.props;

        let output = "";
        let itemArray = [listedFieldItem.fieldName];

        if (listedFieldItem.fieldName.includes("+") === true) {
            itemArray = listedFieldItem.fieldName.split("+");
        }
        itemArray.forEach(itemElement => {
            if (itemElement.includes(".") === true) {
                let expression = "";
                itemElement.split(".").forEach(element => {
                    expression += '["';
                    expression += element.trim();
                    expression += '"]';
                });
                try {
                    if (output.length > 0) output += " ";
                    output += eval(`recordData.fields${expression}`);
                } catch (ex) {
                    console.log(
                        "error in MobileRecordingShowOverview.render(): recordData.fields${expression}: expression=",
                        expression,
                        ex.message
                    );
                }
            } else {
                if (output.length > 0) output += " ";
                output += recordData.fields[`${itemElement}Display`];
            }
        });

        return output;
    };

    render = () => {
        const {currentRecordingFlowChart} = this.props;
        const {toastIsClosed} = this.state;

        let buttons = [];
        let data = [];
        let columns = [];

        const ReactTableFixedColumns = withFixedColumns(ReactTable);

        if (
            currentRecordingFlowChart.automatic &&
            currentRecordingFlowChart.automatic.duration &&
            currentRecordingFlowChart.automatic.type
        ) {
            switch (currentRecordingFlowChart.automatic.type) {
                case "save":
                case "continue":
                    this.onCloseToastHandler = this.onFieldContinue;
                    break;
                case "cancel":
                    this.onCloseToastHandler = this.onFieldCancel;
                    break;
                default:
            }
            if (!this.toastIsOpened) {
                toast.info(currentRecordingFlowChart.automatic.title.text, {
                    autoClose: currentRecordingFlowChart.automatic.duration,
                    position: "bottom-right",
                    onClose: () => this.closeToast()
                });
                this.toastIsOpened = true;
            }
        }

        if (this.props.currentRecordingFlowChart.buttons) {
            for (const itButton of this.props.currentRecordingFlowChart.buttons) {
                switch (itButton.type) {
                    case "save":
                        buttons.push(
                            <MobileSaveButton
                                onClick={() => {
                                    this.clickButton(this.onFieldContinue);
                                }}
                                title={itButton.title}
                            />
                        );
                        break;
                    case "cancel":
                        buttons.push(
                            <MobileCancelButton
                                onClick={() => {
                                    this.clickButton(this.onFieldCancel);
                                }}
                                title={itButton.title}
                            />
                        );
                        break;
                    default:
                }
            }
        }

        columns = [
            {
                Header: "Feld",
                accessor: "field",
                Footer: () =>
                    toastIsClosed === false && buttons.length >= 1 ? buttons[0] : null
            },
            {
                Header: "Wert",
                accessor: "value",
                Footer: () =>
                    toastIsClosed === false && buttons.length >= 2 ? buttons[1] : null
            }
        ];
        let counter = 0;
        for (const listedFieldItem of currentRecordingFlowChart.listedFields) {
            data.push({
                id: counter++,
                field: listedFieldItem.title.text,
                value: this.getOutputData(listedFieldItem)
            });
        }
        return (
            <React.Fragment>
                <ReactTableFixedColumns
                    columns={columns}
                    data={data}
                    defaultPageSize={data.length}
                    showPagination={false}
                    //style={{ height: window.innerHeight }}
                />
            </React.Fragment>
        );
    }
}

export default MobileRecordingShowOverview;
